<template>
	<div class="toast-container">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'ToastContainer'
};
</script>

<style lang="scss" scoped>
.toast-container {
	display: flex;
	position: fixed;
	z-index: 9999;
	flex-direction: column;
	transition: 0.5s top ease-in-out;
	right: $gutter-lg;

	// DEV: Update the top value to 12px when the user scroll the page and the header is not visible
	top: 63px;
}
</style>
